import React from "react";
import "./homeSecOne.scss";
import Positions from "../../component/TypeWritter";
import { com, label, sec1 } from "../../data/MainData";
import Pbutton from "../../component/PrimaryButton";
import image1 from "../../assest/heroImg.gif"

const homeSecOne = () => {
  return (

     
        <div className="secone-container">
          
          <div className="sec1-inner">
                  
            <div className="sec1-left">
              <p className="sec1_text1">{sec1.tag1}</p>
              <div className="sec1_name">
                <div>{com.firstname}</div>
                <div>{com.lastname}</div>
              </div>
              <div>
                <Positions />
              </div>
              
              <div className="main-btn">
                <Pbutton
                  label = {label.btn_des1}
                  link ={'#contact'}
                />
              </div>
            </div>
            <div className="sec1-right">
                <div className="sec1-img">
                  <img src={image1} width={1500}  alt="" />
                </div>
            </div>
          </div>
          
        </div>
   

  );
};

export default homeSecOne;
